export default "__VITE_ASSET__91eb22cf__"